import { Component, OnInit, inject } from '@angular/core';
import { I18nService } from '@shared/i18n/i18n.service';
import { PageTitleService } from '@shared/page-title';
import { ColorSchemeManagerService } from '@shared/services/color-scheme-manager';
import { MatIconRegistry } from '@angular/material/icon';
import { selectLocale, setLocale, StoreService } from '@shared/store';
import { setDebugSettings } from '@shared/store/slices/debug';
import { Environment, ENVIRONMENT } from './environment-provider';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly environment = inject<Environment>(ENVIRONMENT);
  private readonly i18nService = inject(I18nService);
  private readonly pageTitle = inject(PageTitleService);
  private readonly colorSchemeManager = inject(ColorSchemeManagerService);
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly store = inject(StoreService);

  public get production() {
    return this.environment.production;
  }

  public ngOnInit(): void {
    this.store.dispatch(setDebugSettings({ enabled: !this.environment.production }));
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    this.colorSchemeManager.init();
    this.pageTitle.setBaseTitle(this.i18nService.getPhrase('title'));
    this.pageTitle.pageTitleFormatter = (base, page) => `${page} · ${base}`;
    this.pageTitle.on();
    this.initI18n();
  }

  initI18n() {
    const locale = this.store.select(selectLocale());
    if (locale) {
      this.i18nService.changeLanguage(locale);
    }

    this.i18nService.languageChanged.subscribe((lang) => {
      if (lang === 'cimode') {
        return;
      }
      this.store.dispatch(setLocale({ locale: lang }));
    });
  }
}
